export class Document {
  fileType: string;
  fileSize: number;
  fileName: string;
  fileDownloadUri: string;
  id: number;
}
